import { render } from "./GridPagination.vue?vue&type=template&id=6e3f41cb"
import script from "./GridPagination.vue?vue&type=script&lang=js"
export * from "./GridPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__